// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { profileManager, inventoryController, levelRandomiser, gameController, flowController } from "../../game_theme/flow_fb/flowController";
import { tbVector } from "../engine/tbVector";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { SinglePlayerOpponents, FakeOpponents, skillRankSettings, CardSettings, PowerUpSettings } from "../settings/Settings";
import { PhysicsObjectDefinition } from "../settings/blocks";
import { AngryAnalytics } from "./Analytics/Analytics";
import { PlayController } from "./PlayController";
import { Playback } from "./Playback";
import { ReplayData } from "./ReplayData";
import { SceneController, SceneControllerState, physics } from "./SceneController";
import { playController } from "./gameController";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var AIController = {
    // Turn ended callback
    _onTurnEnd: null,
    // Game over callback
    _onGameOver: null,
    // AI player cards
    _cards: [],
    // ReplayData used to record AI actions
    _replayData: null,
    // After an action this is used to wait for the physics to settle
    _isWaitingForIdleBlocks: false,
    // If true the next action is executed on the next step
    _mustDoNextAction: false,
    // If true it will activate the bird ability at the right time
    _canUseBirdAbility: false,
    // vector pool used in the physics
    _points: [],
    // true if powerups where handled this turn
    _triedToUsePowerupThisTurn: false,
    // object that stores the settings for the AI / fake random
    _settings: null,
};
var AI_DATA = "aiMatches";
var AI_ID_COUNTER = "aiIdCounter";
AIController.initialize = function () {
    //Load profile images with some fake ids for the ai opponent
    for (var i = 0; i < SinglePlayerOpponents.length; i++) {
        var o = SinglePlayerOpponents[i];
        profileManager.setName(o.id, o.name);
        profileManager.setImage(o.id, o.image);
    }
    for (var i = 0; i < FakeOpponents.length; i++) {
        var o = FakeOpponents[i];
        profileManager.setName(o.id, o.name);
        profileManager.setImage(o.id, o.image);
    }
    // Init the point pool
    // This is used with the physics to avoid creating new vectors every frame
    for (var i = 0; i < 80; i++) {
        this._points.push(new tbVector(0, 0));
    }
};
AIController.isLastShot = function () {
    return this._cards.length === 0;
};
AIController.getPlayerData = function () {
    var self = this;
    YoutubeStorageManager.getPlayerData(["skillPoints", "streak"], function (data) {
        if (!data.streak) {
            self._streak = 0;
        }
        else {
            self._streak = data.streak;
        }
        if (!data.skillPoints) {
            self._skillPoints = 0;
        }
        else {
            self._skillPoints = data.skillPoints;
        }
        AngryAnalytics.reportSkillRank();
    }, function (error) {
        throw new Error("AI: Error while getting skill points data - " + error);
    });
};
AIController.savePlayerRank = function (didWin) {
    var self = this;
    // we now have skill points. Next up we want to add / remove points from it based on win / loss and streak;
    if (didWin == true) {
        self._streak = Math.max(0, self._streak + 1);
        self._skillPoints += 1 + self._streak;
    }
    else {
        self._streak = Math.min(0, (self._streak - 1));
        self._skillPoints += -1 + self._streak;
    }
    self._skillPoints = Math.max(0, self._skillPoints);
    // save the new values
    YoutubeStorageManager.savePlayerData(["skillPoints", "streak"], [self._skillPoints, self._streak], function () { });
};
AIController._calculateRank = function () {
    var rank = 0;
    // make sure the points are capped at the max
    for (var i = 0; i < skillRankSettings.length; i++) {
        if (this._skillPoints >= skillRankSettings[i].pointRequirement) {
            rank = i;
        }
    }
    if (skillRankSettings[rank].maximumPoints) {
        this._skillPoints = Math.min(this._skillPoints, skillRankSettings[rank].maximumPoints);
    }
    if (this._streak <= 0 && rank > 0) {
        rank--;
    }
    return rank;
};
AIController.getAILevel = function (type) {
    if (type === "random") {
        return skillRankSettings[this._calculateRank()].rankName;
    }
    else {
        return "default";
    }
};
AIController.getAnalyticsAILevel = function () {
    return skillRankSettings[this._calculateRank()].rankName;
};
AIController.getDisplayRank = function () {
    return this.displayRank;
};
AIController._calculateDisplayRank = function () {
    var profile = skillRankSettings[this._calculateRank()];
    var minRank = profile.minExpRank;
    var maxRank = profile.maxExpRank;
    return minRank + Math.floor(Math.random() * (maxRank - minRank + 1));
};
// Creates a valid match data and saves it in the player storage
// This is marked as a lost game. (The user loses if they quit the game)
AIController.createMatch = function (settings, isFake, onDone) {
    var self = this;
    this._settings = settings;
    var skillRank = Math.max(0, this._calculateRank());
    this.difficultySettings = skillRankSettings[skillRank].AISettings;
    this.displayRank = this._calculateDisplayRank();
    // overwrite settings variables with difficulty settings
    for (var i in this.difficultySettings) {
        if (this._settings[i]) {
            this._settings[i] = this.difficultySettings[i];
        }
    }
    YoutubeStorageManager.getPlayerData([AI_DATA, AI_ID_COUNTER], function (serverData) {
        if (!serverData[AI_DATA]) {
            serverData[AI_DATA] = [];
        }
        var counter = serverData[AI_ID_COUNTER];
        if (!counter) {
            counter = 0;
        }
        var bot = AIController._getRandomProfile(isFake);
        var initialData = PlayController.GetInitialMatchData(false, settings.practiceLevels);
        initialData["data"]["otherPlayerData"]["id"] = bot.id;
        initialData["data"]["otherPlayerData"]["name"] = bot.name;
        initialData["data"]["otherPlayerData"]["img"] = "";
        var matchID = self._generateUniqueMatchID(flowController.playerID, counter);
        counter++;
        var creationTime = Date.now() - inventoryController._serverTimeDiff;
        var expirationTime = creationTime + self._settings.matchDurationInMiliseconds;
        var matchData = {
            "levelSettings": {
                "levelIndex": 0
            },
            "lobby": {
                "state": "GAMEOVER",
                "matchID": matchID,
                "context": 0,
                "watchedFinalReplay": 5,
                "isRandomOpponent": false,
                "isAI": true,
                "lastTurnID": flowController.playerID,
                "initiatingPlayerData": {
                    "id": flowController.playerID,
                    "won": false
                },
                "otherPlayerData": {
                    "id": bot.id,
                    "name": bot.name,
                    "won": true
                },
            },
            "id": matchID,
            "_challengeData": {
                "creationDate": new Date(creationTime),
                "isLastMatchFromContext": false,
                "expirationDate": new Date(expirationTime),
                "challenger": flowController.playerID,
                "state": "RUNNING"
            }
        };
        serverData[AI_DATA].push(matchData);
        YoutubeStorageManager.savePlayerData([AI_DATA, AI_ID_COUNTER], [serverData[AI_DATA], counter], function () {
            onDone(matchID, initialData);
        }, function (error) {
            throw new Error("AI: Error while creating match on server - " + error);
        });
    }, function (error) {
        throw new Error("AI: Error while creating match on server - " + error);
    });
};
AIController.getSinglePlayerMatches = function (retData, onDone) {
    YoutubeStorageManager.getPlayerData([AI_DATA], function (data) {
        var d = data[AI_DATA];
        if (d) {
            for (var i = 0; i < d.length; i++) {
                var key = d[i]["id"];
                retData[key] = d[i];
                // fix the dates
                retData[key]["_challengeData"]["creationDate"] = new Date(retData[key]["_challengeData"]["creationDate"]);
                retData[key]["_challengeData"]["expirationDate"] = new Date(retData[key]["_challengeData"]["expirationDate"]);
            }
        }
        onDone(retData);
    }, function (error) {
        throw new Error("AI: Error while single player matches - " + error);
    });
};
AIController.removePlayerFromMatches = function (matchIDs, onDone) {
    YoutubeStorageManager.getPlayerData([AI_DATA], function (serverData) {
        var d = serverData[AI_DATA];
        for (var i = 0; i < matchIDs.length; i++) {
            for (var k = 0; k < d.length; k++) {
                if (d[k]["id"] === matchIDs[i]) {
                    d.splice(k, 1);
                    k--;
                }
            }
        }
        YoutubeStorageManager.savePlayerData([AI_DATA], [d], function () {
            onDone();
        }, function (error) {
            throw new Error("AI: Error while deleting match - " + error);
        });
    }, function (error) {
        throw new Error("AI: Error while deleting match - " + error);
    });
};
AIController.updateMatchData = function (matchID, playerWon, onDone) {
    // Calculate Rank and save data
    this.savePlayerRank(playerWon);
    if (playerWon) {
        YoutubeStorageManager.getPlayerData([AI_DATA], function (serverData) {
            var d = serverData[AI_DATA];
            for (var k = 0; k < d.length; k++) {
                if (d[k]["id"] === matchID) {
                    d[k]["lobby"]["initiatingPlayerData"]["won"] = playerWon;
                    d[k]["lobby"]["otherPlayerData"]["won"] = !playerWon;
                }
            }
            YoutubeStorageManager.savePlayerData([AI_DATA], [d], function () {
                onDone();
            }, function (error) {
                throw new Error("AI: Error while updating match data - " + error);
            });
        }, function (error) {
            throw new Error("AI: Error while updating match data - " + error);
        });
    }
    else {
        onDone();
    }
};
AIController.startTurn = function (onTurnEnd, onGameOver) {
    this._onTurnEnd = onTurnEnd;
    this._onGameOver = onGameOver;
    this._overrideSceneController();
    var sc = playController.sceneController;
    if (sc.entryData["roundNumber"] === 0) {
        levelRandomiser.AddLevelToPlayHistory(playController.levelIndex);
    }
    sc.entryData["roundNumber"] = sc.entryData["roundNumber"] + 1;
    var birdOptions = this.difficultySettings.birdOptions;
    this._cards = SceneController.getRandomCards(sc.entryData["roundNumber"], birdOptions);
    this._triedToUsePowerupThisTurn = false;
    this._replayData = new ReplayData();
    this._doNextAction();
};
/**
 * Overrides SC's functions to tap into callbacks or change functionality
 */
AIController._overrideSceneController = function () {
    var self = this;
    var sc = playController.sceneController;
    this._origHandlePhysicsStep = sc.handlePhysicsStep;
    sc.handlePhysicsStep = function () {
        self._origHandlePhysicsStep.call(sc);
        self._update();
    };
    this._origAddScoreAndSpawnFloaters = sc.addScoreAndSpawnFloaters;
    sc.addScoreAndSpawnFloaters = this._addScoreOverride.bind(this);
};
/**
 * Restore the original SC methods
*/
AIController._restoreSceneController = function () {
    var sc = playController.sceneController;
    sc.handlePhysicsStep = this._origHandlePhysicsStep;
    sc.addScoreAndSpawnFloaters = this._origAddScoreAndSpawnFloaters;
};
AIController._update = function () {
    if (this._canUseBirdAbility) {
        this._handleBirdAbilities();
    }
    if (this._isWaitingForIdleBlocks && playController.sceneController.allBlocksAreIdle) {
        this._isWaitingForIdleBlocks = false;
        this._doNextAction();
    }
    if (this._mustDoNextAction) {
        this._mustDoNextAction = false;
        this._doNextAction();
    }
};
AIController._onPlaybackEnded = function (isEndOfTurn) {
    this._isWaitingForIdleBlocks = isEndOfTurn;
    this._mustDoNextAction = !isEndOfTurn;
};
AIController._doNextAction = function () {
    if (flowController.isOffline) {
        return;
    }
    var sc = playController.sceneController;
    var isGameOver = sc.checkForGameOver();
    sc.saveState();
    if (isGameOver) {
        this._restoreSceneController();
        this._onGameOver(sc.entryData);
    }
    else {
        if (this._cards.length == 0) {
            // Pass the turn to the player
            sc.entryData["roundNumber"] += 1;
            this._replayData.reset();
            sc.changeState(SceneControllerState.BIRD_AVAILABLE);
            sc.allBlocksAreIdle = false;
            playController.sceneBuilder.cameraToSlingshot(true);
            playController.isShooting = false;
            playController.reinitializePowerUpUI();
            playController.updateUI(true);
            playController.uiController.uiPowerUps._enableButtons(true);
            playController.uiController.powerupsUiAnimation = 1;
            playController.uiController.uiAnimation = 1;
            this._restoreSceneController();
            this._onTurnEnd(sc.entryData);
        }
        else {
            // Continue with powerup / next shot
            if (this._cards.length == 1) {
                playController.uiController.toggleShowUIButtons(true);
            }
            this._replayData.reset();
            var slingshot = sc.getSlingshot(true);
            var birdPosition = new tbVector(slingshot.x, slingshot.y);
            var delay = 0;
            if (!this._triedToUsePowerupThisTurn) {
                this._triedToUsePowerupThisTurn = true;
                delay = this._aiUsePowerup(birdPosition);
            }
            else {
                delay = this._shoot(birdPosition);
            }
            playController.isShooting = true;
            this._replayData.setEnd(delay, true);
            sc.playback = new Playback(this._replayData.getData(), this._replayData.getCameraData(), AIController._onPlaybackEnded.bind(this, this._cards.length <= 0));
        }
    }
};
AIController._handleBirdAbilities = function () {
    var sc = playController.sceneController;
    var pigList = sc.pigBlocks;
    for (var i = 0; i < sc.balls.length; i++) {
        var bird = sc.balls[i];
        var birdType = bird.definitionName;
        var velocityScale = 0.2;
        if (birdType == "BlackBird") {
            // check if in range of piggers and boom
            if (!pigList)
                return;
            if (pigList.length == 0)
                return;
            for (var index = 0; index < pigList.length; index++) {
                var selectedPig = pigList[index];
                if (selectedPig.isAlly == true && selectedPig.health > 0) {
                    var birdPosition = new tbVector(bird.x, bird.y);
                    var pigPosition = new tbVector(selectedPig.x, selectedPig.y);
                    var distance = birdPosition.distance(pigPosition);
                    if (distance < 7) {
                        bird.needToActivateSpecialPower = true;
                        this._canUseBirdAbility = false;
                    }
                }
            }
            break;
        }
        var velocity = bird.velocity.scale(velocityScale);
        if (velocity.length() > 0) {
            var start = new tbVector(bird.x, bird.y);
            start.addDirect(velocity.scale(0.25));
            var end = start.add(velocity);
            var rayCast = physics.rayCast(start, end);
            if (rayCast.hit == true) {
                bird.needToActivateSpecialPower = true;
                this._canUseBirdAbility = false;
            }
        }
    }
};
AIController._getRandomProfile = function (isFake) {
    if (isFake) {
        return FakeOpponents[Math.floor(Math.random() * FakeOpponents.length)];
    }
    else {
        return SinglePlayerOpponents[0];
    }
};
// Generates a match id based on the user id and a counter
AIController._generateUniqueMatchID = function (playerID, counter) {
    var halfLength = 16;
    var pad = Array(halfLength).join('0');
    var part1 = (pad + playerID).slice(-halfLength);
    var part2 = (pad + counter).slice(-halfLength);
    return part1 + part2;
};
AIController._getShot = function (birdPosition, birdRadius) {
    var shotList = [];
    var maxLaunchForce = PhysicsSettings.slingshotMaxForce;
    // Populate list of shots with multiple launch forces
    var segments = 8;
    for (var i = segments; i > 0; i--) {
        var forceMultiplier = i / segments;
        var launchForce = maxLaunchForce * forceMultiplier;
        shotList = shotList.concat(this._aiGetBestShots(birdPosition, launchForce, birdRadius));
    }
    // Fail safe in case the pigs cannot be reached; add force until pigs can get reached
    var launchForce = maxLaunchForce;
    while (shotList.length == 0 && launchForce < maxLaunchForce * 1.5) {
        shotList = this._aiGetBestShots(birdPosition, launchForce, birdRadius);
        launchForce = launchForce + 1;
    }
    // Index the shots for later sorting
    for (var i = 0; i < shotList.length; i++) {
        shotList[i].index = i;
    }
    // Create a sorted list based on hit distance
    var hitDistance_shotList = shotList.slice();
    hitDistance_shotList.sort(function (a, b) { return (a.hitDistance - b.hitDistance); });
    // Create a sorted list based on hit step (physics step of collission)
    var hitStep_shotList = shotList.slice();
    hitStep_shotList.sort(function (a, b) { return (a.hitStep - b.hitStep); });
    // Give each shot a 'score' based on their position in each sorted list
    for (var i = 0; i < shotList.length; i++) {
        var summedScore = 0;
        for (var j = 0; j < hitDistance_shotList.length; j++) {
            if (hitDistance_shotList[j].index == i) {
                summedScore += j;
                break;
            }
        }
        for (var k = 0; k < hitStep_shotList.length; k++) {
            if (hitStep_shotList[k].index == i) {
                summedScore += k / 4;
                break;
            }
        }
        shotList[i].summedScore = summedScore;
    }
    // Sort the list based on this score
    shotList.sort(function (a, b) { return (a.summedScore - b.summedScore); });
    return shotList[0];
};
AIController._applyAngleOffset = function (direction) {
    // Take into account the shot # of the current turn.
    // --> It should never miss 3 times, it should 'adjust' its shots
    var currentShot = CardSettings.cardsPerTurn - this._cards.length; // 1 -> 2 -> 3
    var angleOffset = this.difficultySettings.angleMinOffset + Math.round(Math.random() * (this.difficultySettings.angleMaxOffset - this.difficultySettings.angleMinOffset));
    angleOffset = angleOffset / currentShot;
    var offsetMultiplier = -1 + 2 * Math.floor(Math.random() * 2);
    direction.rotateDirect(offsetMultiplier * angleOffset);
};
/**
 *  Returns the replay delay needed
 */
AIController._shoot = function (birdPosition) {
    var sc = playController.sceneController;
    var selectedBird = this._cards[0];
    this._cards.splice(0, 1);
    var birdRadius = PhysicsObjectDefinition[selectedBird].height / 2;
    var bestShot = this._getShot(birdPosition, birdRadius);
    // for difficulty
    this._applyAngleOffset(bestShot.shot);
    var shot = {
        "birdPosition": birdPosition,
        "selectedBirdName": selectedBird,
        "launchForce": bestShot.launchForce,
        "launchDirection": bestShot.shot
    };
    this._replayData.setCameraPanStart(0);
    this._replayData.setShot(shot, 0);
    var secondsToPhysSteps = 1 / PhysicsSettings.physicsTimeStep;
    var delayBetweenShots = bestShot.hitStep + this._settings.secondsToWaitAfterImpact * secondsToPhysSteps;
    this._canUseBirdAbility = true;
    return delayBetweenShots;
};
/**
 *  Returns the replay delay needed
 */
AIController._aiUsePowerup = function (birdPosition) {
    "use strict";
    if (Math.random() > this._settings.chanceToUsePowerup) {
        // no powerup used
        return this._settings.secondsToWaitAfterNoPowerup;
    }
    var bestShotList = this._aiGetBestShots(birdPosition, PhysicsSettings.slingshotMaxForce);
    var data = this._replayData;
    var secondsToPhysSteps = 1 / PhysicsSettings.physicsTimeStep;
    var time = secondsToPhysSteps;
    var powerups = gameController.createShuffledIndexArray(5);
    var didUsePowerup = false;
    if (bestShotList.length == 0) {
        return 0;
    }
    for (var i = 0; i < powerups.length; i++) {
        if (didUsePowerup) {
            break;
        }
        switch (powerups[i]) {
            case 0: // TNT
                var tntRange = PowerUpSettings.tntSettings.pushRange;
                var pigPairs = this._aiGetPigsWithinDistance(tntRange * 1.5, false);
                var position = new tbVector(0, 0);
                if (pigPairs.length > 0) {
                    var selectedPair = pigPairs[0];
                    if (pigPairs.length > 1) {
                        var randomPair = Math.floor(Math.random() * pigPairs.length);
                        selectedPair = pigPairs[randomPair];
                    }
                    position.x = selectedPair.middlePoint.x;
                    position.y = selectedPair.middlePoint.y;
                }
                else {
                    var randomTarget = Math.floor(Math.random() * bestShotList.length);
                    var targetPig = bestShotList[randomTarget].target;
                    position.x = targetPig.x;
                    position.y = targetPig.y - 5;
                }
                data.setPowerupIcon({ position: position, power: "BombDrop" }, time - secondsToPhysSteps);
                data.setTNT({ position: position }, time);
                //power == "TNT"
                didUsePowerup = true;
                break;
            case 1: // SHIELD 
                var friendlyPigList = this._aiGetPigs(true);
                var randomFriendlyPig = friendlyPigList[Math.floor(Math.random() * friendlyPigList.length)];
                var position = new tbVector(randomFriendlyPig.x, randomFriendlyPig.y);
                var worldIndex = this._getWorldIndex(randomFriendlyPig);
                data.setPowerupIcon({ position: position, power: "Shield" }, time - secondsToPhysSteps);
                data.setLife({ index: worldIndex }, time);
                didUsePowerup = true;
                break;
            case 2: // ICE
                var iceRange = PowerUpSettings.freezeRaySettings.radius;
                var pigPairs = this._aiGetPigsWithinDistance(iceRange * 1.5, false);
                var position = new tbVector(0, 0);
                if (pigPairs.length > 0) {
                    var selectedPair = pigPairs[0];
                    if (pigPairs.length > 1) {
                        var randomPair = Math.floor(Math.random() * pigPairs.length);
                        selectedPair = pigPairs[randomPair];
                    }
                    position.x = selectedPair.middlePoint.x;
                    position.y = selectedPair.middlePoint.y;
                }
                else {
                    var targetPig = bestShotList[bestShotList.length - 1].target;
                    position.x = targetPig.x;
                    position.y = targetPig.y;
                }
                var objectsAroundPosition = this._getObjectsInRange(position, iceRange);
                if (objectsAroundPosition.length < 4)
                    break;
                var materialDistribution = this._getMaterialDistribution(objectsAroundPosition);
                if (materialDistribution["Ice"] > materialDistribution["Stone"]
                    && materialDistribution["Ice"] > materialDistribution["Wood"]) {
                    console.log("too many Ices! ABORT MISSION!");
                    break;
                }
                data.setPowerupIcon({ position: position, power: "FreezeRay" }, time - secondsToPhysSteps);
                data.setIce({ position: position }, time);
                didUsePowerup = true;
                break;
            case 3: // STONE
                var stoneRange = PowerUpSettings.stoneNatorSettings.radius;
                var pigPairs = this._aiGetPigsWithinDistance(stoneRange * 1.5, true);
                var position = new tbVector(0, 0);
                if (pigPairs.length > 0) {
                    var selectedPair = pigPairs[0];
                    if (pigPairs.length > 1) {
                        var randomPair = Math.floor(Math.random() * pigPairs.length);
                        selectedPair = pigPairs[randomPair];
                    }
                    position.x = selectedPair.middlePoint.x;
                    position.y = selectedPair.middlePoint.y;
                }
                else {
                    var friendlyPigList = this._aiGetPigs(true);
                    var randomFriendlyPig = friendlyPigList[Math.floor(Math.random() * friendlyPigList.length)];
                    position.x = randomFriendlyPig.x;
                    position.y = randomFriendlyPig.y;
                }
                var objectsAroundPosition = this._getObjectsInRange(position, stoneRange);
                if (objectsAroundPosition.length < 4)
                    break;
                var materialDistribution = this._getMaterialDistribution(objectsAroundPosition);
                if (materialDistribution["Stone"] > materialDistribution["Ice"]
                    && materialDistribution["Stone"] > materialDistribution["Wood"]) {
                    console.log("too many stones! ABORT MISSION!");
                    break;
                }
                data.setPowerupIcon({ position: position, power: "StoneNator" }, time - secondsToPhysSteps);
                data.setStone({ position: position }, time);
                didUsePowerup = true;
                break;
            case 4: // pig swappers
                var hardestShot = bestShotList[bestShotList.length - 1];
                var targetPig = hardestShot.target;
                var targetPigMaterialName = targetPig.definition.materialName;
                var friendlyPigList = this._aiGetPigs(true);
                var highestPig = null;
                for (var i = 0; i < friendlyPigList.length; i++) {
                    var selectedFriendlyPig = friendlyPigList[i];
                    var selectedMaterialName = selectedFriendlyPig.definition.materialName;
                    if (targetPigMaterialName == selectedMaterialName) {
                        if (highestPig == null) {
                            highestPig = selectedFriendlyPig;
                        }
                        else if (selectedFriendlyPig.y < highestPig.y) {
                            highestPig = selectedFriendlyPig;
                        }
                    }
                }
                if (highestPig == null)
                    break;
                var pos1 = new tbVector(targetPig.x, targetPig.y);
                var pos2 = new tbVector(highestPig.x, highestPig.y);
                data.setPowerupIcon({ position: pos1, power: "SwapPigs" }, time - secondsToPhysSteps);
                data.setPowerupIcon({ position: pos2, power: "SwapPigs" }, time - secondsToPhysSteps);
                data.setSwapPigs({ "index1": targetPig.id, "index2": highestPig.id }, time);
                didUsePowerup = true;
                break;
        }
    }
    return this._settings.secondsToWaitAfterPowerup * secondsToPhysSteps;
};
AIController._aiGetBestShots = function (birdPosition, launchForce, birdRadius) {
    "use strict";
    var targetList = this._aiGetTargetPigs(birdPosition);
    var bestShots = [];
    if (!birdRadius) {
        birdRadius = PhysicsObjectDefinition["RedBird"].height / 2;
    }
    var possibleShots = [];
    for (var index = 0; index < targetList.length; index++) {
        var selectedTarget = targetList[index];
        var targetPosition = new tbVector(selectedTarget.x, selectedTarget.y);
        var newCalculatedAngles = physics.getPossibleLaunchAngles(targetPosition, birdPosition, launchForce, PhysicsSettings.gravity);
        if (newCalculatedAngles.length <= 0)
            continue;
        for (var j = 0; j < newCalculatedAngles.length; j++) {
            var newCalculatedDirection = new tbVector(-Math.cos(newCalculatedAngles[j]), -Math.sin(newCalculatedAngles[j]));
            var shotWithTarget = {
                target: selectedTarget,
                shot: newCalculatedDirection
            };
            possibleShots.push(shotWithTarget);
        }
    }
    var distancesPerShot = [];
    // Now we have a list of all possible shots on all targets. Ray trace each path and check resistance
    for (var index = 0; index < possibleShots.length; index++) {
        var selectedShot = possibleShots[index].shot; // tbVector
        var startVelocity = selectedShot.scale(launchForce);
        var selectedTarget = possibleShots[index].target;
        var targetPosition = new tbVector(selectedTarget.x, selectedTarget.y);
        // integer >= 1
        // the greater it is the less accurate the physics calculations are (but faster)
        var physicsStepMultiplier = 5;
        // Check if there is no static ground blocking the shot
        var invalidObjectNames = [{ filter: "startsWith", name: "TERRAIN" }];
        var validObjectNames = [{ filter: "endsWith", name: "_ALLY" }];
        var filterFunction = function (body) {
            var hitObject = body.physicsObj;
            for (var invalidNameIndex in invalidObjectNames) {
                var selection = invalidObjectNames[invalidNameIndex];
                var filter = selection.filter;
                var name = selection.name;
                if (hitObject.definitionName[filter](name)) {
                    return false;
                }
            }
            for (var validNameIndex in validObjectNames) {
                var selection = validObjectNames[validNameIndex];
                var filter = selection.filter;
                var name = selection.name;
                if (hitObject.definitionName[filter](name)) {
                    return true;
                }
            }
        };
        var isValid = physics.isTrajectoryValid(this._points, birdPosition, startVelocity, physicsStepMultiplier, targetPosition, birdRadius, filterFunction);
        if (isValid) {
            var distanceFromHitpoint = physics.getTrajectoryResistanceDistance(this._points, birdPosition, startVelocity, physicsStepMultiplier, targetPosition, birdRadius);
            var distanceWithShot = {
                shot: selectedShot,
                hitDistance: distanceFromHitpoint.distance,
                target: selectedTarget,
                hitStep: distanceFromHitpoint.hitStep,
                launchForce: launchForce,
                hitObject: distanceFromHitpoint.hitObject
            };
            distancesPerShot.push(distanceWithShot);
        }
    }
    // now sort the list based on resistances
    distancesPerShot.sort(function (a, b) { return (a.hitDistance - b.hitDistance); });
    return distancesPerShot;
};
AIController._aiGetTargetPigs = function (birdPosition) {
    var targetList = [];
    var pigList = playController.sceneController.pigBlocks;
    if (!pigList || pigList.length == 0) {
        return;
    }
    for (var index = 0; index < pigList.length; index++) {
        var selectedPig = pigList[index];
        if (selectedPig.isAlly == true) {
            if (selectedPig.health > 0) {
                targetList.push(selectedPig);
            }
        }
    }
    return targetList;
};
AIController._getWorldIndex = function (object) {
    "use strict";
    var worldIndex = -1;
    var blocks = playController.sceneController.levelBlocks;
    for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].id == object.id) {
            worldIndex = i;
            break;
        }
    }
    return worldIndex;
};
AIController._getObjectsInRange = function (position, range) {
    "use strict";
    var objectList = [];
    var blocks = playController.sceneController.levelBlocks;
    for (var i = 0; i < blocks.length; i++) {
        var selectedBlock = blocks[i];
        var blockPosition = new tbVector(selectedBlock.x, selectedBlock.y);
        if (position.distance(blockPosition) <= range) {
            objectList.push(selectedBlock);
        }
    }
    return objectList;
};
AIController._getMaterialDistribution = function (objectList) {
    "use strict";
    var materialList = {};
    for (var i = 0; i < objectList.length; i++) {
        var selectedBlock = objectList[i];
        var key = selectedBlock.definition.materialName;
        if (!materialList[key]) {
            materialList[key] = 0;
        }
        materialList[key]++;
    }
    return materialList;
};
AIController._aiGetPigs = function (isFriendly) {
    "use strict";
    var retPigList = [];
    var pigList = playController.sceneController.pigBlocks;
    if (!pigList) {
        return;
    }
    if (pigList.length == 0) {
        return;
    }
    for (var index = 0; index < pigList.length; index++) {
        var selectedPig = pigList[index];
        if (selectedPig.isAlly == !isFriendly) {
            if (selectedPig.health > 0) {
                retPigList.push(selectedPig);
            }
        }
    }
    return retPigList;
};
AIController._aiGetPigsWithinDistance = function (distance, isFriendly) {
    "use strict";
    var pigPairs = [];
    var pigList = this._aiGetPigs(isFriendly);
    if (pigList.length > 0) {
        for (var index = 0; index < pigList.length; index++) {
            var selectedPig = pigList[index];
            for (var j = index; j < pigList.length; j++) {
                var comparingPig = pigList[j];
                if (selectedPig == comparingPig)
                    continue;
                var pos1 = new tbVector(selectedPig.x, selectedPig.y);
                var pos2 = new tbVector(comparingPig.x, comparingPig.y);
                var distanceBetweenPigs = pos1.distance(pos2);
                if (distanceBetweenPigs < distance) {
                    var midPoint = pos1.add(pos2).scale(0.5);
                    var pigPairObject = {
                        pig1: selectedPig,
                        pig2: comparingPig,
                        middlePoint: midPoint
                    };
                    pigPairs.push(pigPairObject);
                }
            }
        }
        return pigPairs;
    }
    return false;
};
AIController._addScoreOverride = function (points, block) {
    var sc = playController.sceneController;
    if (sc.firstBirdFired) {
        sc.entryData["otherPlayerData"]["score"] += points;
        playController.updateUI();
    }
};
